import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import Button from "../Button";

import settings from "../../config";
import Header from "../Header";
import Input from "../Input/Input";

const AssetForm = () => {
  const navigate = useNavigate();
  const { productionAssetId } = useParams();

  const [formData, setFormData] = useState({
    productionAssetName: "",
    price: 0,
  });

  useEffect(() => {
    if (productionAssetId) {
      (async () => {
        const response = await axios.post(
          `${settings.api}production-assets/view`,
          {
            productionAssetId,
          },
        );

        if (response.data.data) {
          setFormData(response.data.data[0]);
        }
      })();
    }
  }, [productionAssetId]);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <form
      dir="rtl"
      onSubmit={async (e) => {
        e.preventDefault();

        const response = await axios.post(
          `${settings.api}production-assets/${
            productionAssetId ? "update" : "create"
          }`,
          formData,
        );

        if (response.data.statusCode === 200) {
          navigate("/production-assets");
        }
      }}
    >
      <div className="w-full">
        <Header title="استماره متطلب انتاج" />

        <div className="flex flex-col w-full lg:w-1/2 m-auto gap-4">
          <Input
            label="اسم متطلب انتاج"
            value={formData.productionAssetName}
            onChange={onChange}
            name="productionAssetName"
            required
          />

          <Button
            type="submit"
            text="تسجيل"
            isDisabled={!formData.productionAssetName}
          />
        </div>
      </div>
    </form>
  );
};

export default AssetForm;
